import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/store.js'
import fxViewComponent from '@/components/fxView'
const noFound = () => import('@/components/fxView/shared/noFound')
//-------------------------request_access----------------------------------------------------------------
const request_access = () => import('@/components/fxView/request/request_access')
const ib_request_access = () => import('@/components/fxView/request/ib_request_access')
//-------------------------task-list------------------------------------------------------------
const task_listing = () => import('@/components/fxView/task/task_listing')
//-------------------------manage-group------------------------------------------------------------
const group_listing = () => import('@/components/fxView/mange_group/group_listing')
const group_view = () => import('@/components/fxView/mange_group/group_view')
const group_add_edit = () => import('@/components/fxView/mange_group/group_add_edit')

//-------------------------coupon----------------------------------------------------------------
const couponListing = () => import('@/components/fxView/coupon/coupon_listing')
const createCoupon = () => import('@/components/fxView/coupon/create_coupon')

//-----------------------NOTIFICATION LIST------------------------------------------------------
const notificationListing = () => import('@/components/fxView/notification/notification_listing')
const notificationListingOld = () => import('@/components/fxView/notification/notification_listing_old')

//-------------------------admin----------------------------------------------------------------
const adminListing = () => import('@/components/fxView/admin/admin_listing')
const adminView = () => import('@/components/fxView/admin/admin_view')
const adminAdd = () => import('@/components/fxView/admin/create_admin')
const rm_accuracy = () => import('@/components/fxView/admin/rm_accuracy')
//-------------------------email----------------------------------------------------------------
const emailListing = () => import('@/components/fxView/email/email_listing')
const createEmail = () => import('@/components/fxView/email/create_email')
//-------------------------client----------------------------------------------------------------
const clientListing = () => import('@/components/fxView/client/client_listing')
const clientListingNew = () => import('@/components/fxView/client/client_listing_new')
const logsView = () => import('@/components/fxView/client/logs_view')
const leads = () => import('@/components/fxView/client/leads')
const clientView = () => import('@/components/fxView/client/client_view')
const email_file = () => import('@/components/fxView/log/email_file')
//--------------------------ib------------------------------------------------------------------
const ib_listing = () => import('@/components/fxView/ib/ib_listing')
const ib_view = () => import('@/components/fxView/ib/ib_view')
//-----------------------------------------faq---------------------------------------------------
// const faqCat = () => import('@/components/fxView/faq/create_category')
// const faqArticle = () => import('@/components/fxView/faq/create_article')
// const faqEditCat = () => import('@/components/fxView/faq/edit_category')
// const faqEditArticle = () => import('@/components/fxView/faq/edit_article')
// const catList = () => import('@/components/fxView/faq/category_listing')
// const articleList = () => import('@/components/fxView/faq/article_listing')
//-------------------------admin-----------------------------------------------------------------
const adminLogin = () => import('@/components/fxView/admin/login')
const adminDashboard = () => import('@/components/fxView/admin/dashboard')
//-------------------------ticket-----------------------------------------------------------------
const createTicket = () => import('@/components/fxView/ticket/create_ticket')
const ticketListing = () => import('@/components/fxView/ticket/ticket_list')
const ticketView = () => import('@/components/fxView/ticket/ticket_view')

const ib_ticket_list = () => import('@/components/fxView/ticket/ib_ticket_list')

const internal_deposit_list = () => import('@/components/fxView/ticket/internal_deposit_list')
//-------------------------deposit---------------------------------------------------------------
const depositListing = () => import('@/components/fxView/deposit/deposit_listing')
const depositView = () => import('@/components/fxView/deposit/deposit_view')
const createDeposit = () => import('@/components/fxView/deposit/create_deposit')
const depositTransaction  = () => import('@/components/fxView/deposit/deposit_transaction')
const depositTransactionListing  = () => import('@/components/fxView/deposit/deposit_transaction_list')
//-------------------------bonus---------------------------------------------------------------
const bonusListing = () => import('@/components/fxView/bonus/bonus_listing')
const bonusView = () => import('@/components/fxView/bonus/bonus_view')
const addBonus = () => import('@/components/fxView/bonus/add_bonus')
const removeBonus = () => import('@/components/fxView/bonus/remove_bonus')

//-------------------------withdrawal------------------------------------------------------------
const createWithdrawal = () => import('@/components/fxView/withdrawal/create_withdrawal')
const withdrawalListing = () => import('@/components/fxView/withdrawal/withdrawal_listing')
const withdrawalListingAccount = () => import('@/components/fxView/withdrawal/withdrawal_account_list')
const withdrawalView = () => import('@/components/fxView/withdrawal/withdrawal_view')
//-------------------------trading-account-------------------------------------------------------
const createTrading = () => import('@/components/fxView/trading/create_trading')
const tradingListing = () => import('@/components/fxView/trading/trading_listing')
const tradingView = () => import('@/components/fxView/trading/trading_view')
//-------------------------search-list-------------------------------------------------------
const search = () => import('@/components/fxView/shared/search')
//-------------------------Useer PDF---------------------------------------------------------
const userPDF = () => import('@/components/fxView/client/pdf')
const notes = () => import('@/components/fxView/internal_notes/notes')

//-----------------------------change-password--------------------------------

const changepassword = () => import('@/components/fxView/change_password/change-password')

//------------------------------webinar---------------------------------------------

// const Webinar = () => import('@/components/fxView/webinar/add_webinar')

//--------------------------------tutorial-----------------------------------------
// const Tutorial = () => import('@/components/fxView/Tutorial/tutorials')
// const createTutorial = () => import('@/components/fxView/Tutorial/create-tutorial')

// const createTutCourse = () => import('@/components/fxView/Tutorial/add-tutCourse')
// const TutCourselist = () => import('@/components/fxView/Tutorial/tutorial-course')

// const createTutCat = () => import('@/components/fxView/Tutorial/add-tutCategory')
// const TutorialCatlist = () => import('@/components/fxView/Tutorial/tutorial-category')



//-----------------------------------category--------------------------------------
// const addCategory = () => import('@/components/fxView/category/add-category')
// const addPost = () => import('@/components/fxView/category/add-post')
// const categoryList = () => import('@/components/fxView/category/category-list')
// const postList = () => import('@/components/fxView/category/post-list')


//------------------------------------upload document----------------------------------
const uploadDocument = () => import('@/components/fxView/upload/upload-document')


//-------------------------------------chart-----------------------------------------

const Chart = () => import('@/components/fxView/mapchart/chart')
const chartDesign = () => import('@/components/fxView/mapchart/chart-design')

const Editor = () => import('@/components/fxView/shared/editor')

// //---------------------------------subscription-------------------------------------
// const subscription_listing = () => import('@/components/fxView/subscription/subscription_listing')
// const subscriptionDetail = () => import('@/components/fxView/subscription/subscription_detail')
// const Updatesubscription = () => import('@/components/fxView/subscription/subscription_update')


//---------------------------------vps----------------------------------------------
// const vps_listing = () => import('@/components/fxView/vps/vps_listing')

//-----------------------------------loyality----------------------------------------
const transaction_listing = () => import('@/components/fxView/loyality/loyality-transaction-list')
const card_listing = () => import('@/components/fxView/loyality/loyality-card-list')

//---------------------------------commission----------------------------------------------
const commission_report_listing = () => import('@/components/fxView/commission/commission_report_listing')
const commission_withdrawal_listing = () => import('@/components/fxView/commission/commission_withdrawal_listing')




Vue.use(Router)
const router =  new Router({
	mode: 'history',
	routes: [
		//-------------------------admin-login--------------------------------------------------
		{ path: '/', name: 'admin.adminLogin', component: adminLogin },
		{ path: '/clientpdf', name: 'client.userPDF',  props : true, component: userPDF },
		
		{
			path:'/',
			component: fxViewComponent,
			children:[
				// { path: '/vps-list', name: 'vps_listing',   component: vps_listing },

				//=============================loyality======================================================

				{ path: '/transaction-list', name: 'transaction_listing',   component: transaction_listing },
				{ path: '/card-list', name: 'card_listing',   component: card_listing },
				//====================subscription ===========================================================
				// { path: '/subscription-list', name: 'subscription_listing',   component: subscription_listing },
				// { path: '/subscription-view', name: 'subscriptionDetail',   component: subscriptionDetail },
				// { path: '/update-subscription', name: 'Updatesubscription',   component: Updatesubscription },
				//==========================ib-list==================================================
				{ path: '/ib-list', name: 'ib_listing',   component: ib_listing },
				{ path: '/ib-view', name: 'ib_view',  component: ib_view },
				//====================================================================================
				{ path: '/view-email', name: 'log.email_file',  props : true, component: email_file },
				{ path: '/not-found', name: 'noFound',  component: noFound },
				{ path: '/request-access', name: 'request.request_access',  component: request_access },
				{ path: '/ib-request-access', name: 'request.ib_request_access',  component: ib_request_access },
				//-------------------------task-list------------------------------------------------
				{ path: '/task-listing', name: 'task.task_listing',  component: task_listing },
				{ path: '/notes', name: 'internal_notes.notes',  props : true, component: notes },
				//-------------------------manage-group------------------------------------------------
				{ path: '/group-listing', name: 'mange_group.group_listing',  component: group_listing },
				{ path: '/group-view', name: 'mange_group.group_view',  component: group_view },
				{ path: '/add-edit', name: 'mange_group.group_add_edit',  component: group_add_edit },
				//-------------------------reporting------------------------------------------------
				{ path: '/coupon-listing', name: 'coupon.couponListing',  component: couponListing },
				{ path: '/create-coupon', name: 'coupon.createCoupon',  component: createCoupon },
				
				//-------------------------admin------------------------------------------------
				{ path: '/search', name: 'shared.search',  component: search },

				{ path: '/notification-list', name: 'admin.notificationListing',  component: notificationListing },
				{ path: '/notification-list-old', name: 'admin.notificationListingOld',  component: notificationListingOld },

				//-------------------------admin------------------------------------------------
				{ path: '/admin-list', name: 'admin.adminListing',  component: adminListing },
				{ path: '/admin-view',  name: 'admin.adminView', props : true, component: adminView },
				{ path: '/create-admin',  name: 'admin.adminAdd', props : true, component: adminAdd },
				{ path: '/rm-accuracy',  name: 'admin.rm_accuracy', props : true, component: rm_accuracy },
				//-------------------------email------------------------------------------------
				{ path: '/email-setting-list', name: 'email.emailListing',  component: emailListing },
				{ path: '/create-email',  name: 'email.createEmail', props : true, component: createEmail },
				//-------------------------client------------------------------------------------
				{ path: '/listing', name: 'client.clientListing',  component: clientListing },
				{ path: '/listing-new', name: 'client.clientListingNew',  component: clientListingNew },
				{ path: '/leads', name: 'client.leads',  component: leads },
				{ path: '/logs-view',  name: 'client.logsView', props : true, component: logsView },
				{ path: '/view',  name: 'client.clientView', props : true, component: clientView },
				
				//-------------------------faq---------------------------------------------------
				// { path: '/category',  name: 'faq.faqCat', props : true, component: faqCat },
				// { path: '/articles',  name: 'faq.faqArticle', props : true, component: faqArticle },
				// { path: '/edit-category',  name: 'faq.faqEditCat', props : true, component: faqEditCat },
				// { path: '/edit-article',  name: 'faq.faqEditArticle', props : true, component: faqEditArticle },
				// { path: '/category-list',  name: 'faq.catList', props : true, component: catList },
				// { path: '/articles-list',  name: 'faq.articleList', props : true, component: articleList },
				//-------------------------ticket------------------------------------------------
				{ path: '/create-ticket', name: 'ticket.createTicket',  component: createTicket },
				{ path: '/ticket-list', name: 'ticket.ticketListing',  component: ticketListing },
				{ path: '/ticket-view',  name: 'ticket.ticketView', props : true, component: ticketView },
				{ path: '/internal-deposit-list', name: 'ticket.internal_deposit_list',  component: internal_deposit_list },

				

				{ path: '/ib-ticket-list', name: 'ticket.ib_ticket_list',  component: ib_ticket_list },
				//-------------------------deposit-----------------------------------------------
				{ path: '/create-deposit',  name: 'deposit.createDeposit', props : true, component: createDeposit },
				{ path: '/deposit-list',  name: 'deposit.depositListing',  component: depositListing },
				{ path: '/deposit-view',  name: 'deposit.depositView', props : true, component: depositView },
				{  path: '/transaction-history',  name: 'deposit.depositTransaction',  component: depositTransaction },
				{ path: '/deposit-transaction-list',  name: 'deposit.depositTransactionListing',  component: depositTransactionListing },
				//-------------------------bonus-----------------------------------------------
				{ path: '/bonus-list',  name: 'bonus.bonusListing',  component: bonusListing },
				{ path: '/bonus-view',  name: 'bonus.bonusView', props : true, component: bonusView },
				{ path: '/add-bonus',  name: 'bonus.addBonus', props : true, component: addBonus },
				{ path: '/remove-bonus',  name: 'bonus.removeBonus', props : true, component: removeBonus },
				//-------------------------withdrawal--------------------------------------------
				{ path: '/create-withdrawal', name: 'withdrawal.createWithdrawal',  component: createWithdrawal },
				{ path: '/withdrawal-list',  name: 'withdrawal.withdrawalListing', component: withdrawalListing },
				{ path: '/withdrawal-account-list',  name: 'withdrawal.withdrawalListingAccount', component: withdrawalListingAccount },
				{ path: '/withdrawal-view',  name: 'withdrawal.withdrawalView',  props : true, component: withdrawalView },
				//-------------------------trading-account---------------------------------------
				{ path: '/create-trading',  name: 'trading.createTrading', component: createTrading },
				{ path: '/trading-list',  name: 'trading.tradingListing', component: tradingListing },
				{ path: '/trading-view',  name: 'trading.tradingView',  props : true, component: tradingView },
				//-------------------------admin-------------------------------------------------
				{ path: '/dashboard',   name: 'admin.adminDashboard',  component: adminDashboard },

				//--------------------------------change password---------------------------------
				{ path: '/change-password',   name: 'change_password.changepassword',  component: changepassword },

				//--------------------------------webinar---------------------------------
				// { path: '/webinar',   name: 'add_webinar.Webinar',  component: Webinar },

				//---------------------------------tutorial------------------------------------
				// { path: '/tutorials-list',   name: 'Tutorial.Tutorial',  component: Tutorial },
				// { path: '/create-tutorial',   name: 'Tutorial.createTutorial',  component: createTutorial },

				// { path: '/tutorial-course',   name: 'Tutorial.createTutCourse',  component: createTutCourse },
				// { path: '/tutorial-course-list',   name: 'Tutorial.TutCourselist',  component: TutCourselist },

				// { path: '/tutorial-category',   name: 'Tutorial.createTutCat',  component: createTutCat },
				// { path: '/tutorial-category-list',   name: 'Tutorial.TutorialCatlist',  component: TutorialCatlist },


				//-------------------------------------category-----------------------------------------

				// { path: '/add-category',   name: 'category.addCategory',  component: addCategory },
				// { path: '/add-post',   name: 'category.addPost',  component: addPost },
				// { path: '/category-Listing',   name: 'category.categoryList',  component: categoryList },
				// { path: '/post-list',   name: 'category.postList',  component: postList },

				//------------------------------------upload document------------------------------------
				{ path: '/upload-document',   name: 'upload.uploadDocument',  component: uploadDocument },

				//----------------------------------------chart-------------------------------------------

				{ path: '/chart',   name: 'mapchart.Chart',  component: Chart },
				{ path: '/chart-design',   name: 'mapchart.chartDesign',  component: chartDesign },
				{ path: '/editor',   name: 'shared.Editor',  component: Editor },

				//-------------------------------------commission-----------------------------------------

				{ path: '/commission-report-list',   name: 'commission.commission_report_listing',  component: commission_report_listing },
				{ path: '/commission-withdrawal-list',   name: 'commission.commission_withdrawal_listing',  component: commission_withdrawal_listing },

			]
		}, 

		
		   
	]
})

router.beforeEach((to, from, next) => {
	const userStateVariable = store.state.user
	//let permissionVariable = userStateVariable.permissions.split(',')
	//console.log(permissionVariable.indexOf('ADMIN_LIST'))
	if (to.name !== 'admin.adminLogin'   && ((userStateVariable == null || !'loggedIn' in userStateVariable) || !userStateVariable.loggedIn)) next({ name: 'admin.adminLogin' })
	
	//else if (userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && to.name == 'admin.adminListing' && permissionVariable.indexOf('ADMIN_LIST') >= 0) next({ name: 'admin.adminListing' })
	 
	//else if(userStateVariable !== null && 'loggedIn' in userStateVariable && userStateVariable.loggedIn && to.name == '' && ) next({ name: '' })
	
	else next()
	
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js